import React, {useEffect, useState} from 'react';
import ParticipationDetails from './automation/ParticipationDetails';

export default function AutomationParticipation({chain,participation}) {
  const [data,setData] = useState(participation);
  const [error,setError] = useState('');
  const [reload,setReload] = useState(0);
  useEffect(() => {
    let request;
    let active = true;
    const refresh = async () => {
      request?.abort(); request = new AbortController(); const current=request;
      try {
        const response=await fetch(`/automation-chains/${chain.id}/execution?execution_id=${participation.id}`,{headers:{Accept:'application/json'},signal:current.signal});
        if (!response.ok) throw new Error('Could not update participation. Try again.');
        const result=await response.json();
        if (active && !current.signal.aborted) {setData(result);setError('');}
      } catch (err) {if (active && err.name !== 'AbortError') setError(err.message);}
    };
    const timer=setInterval(refresh,3000);
    if (reload) refresh();
    return () => {active=false;clearInterval(timer);request?.abort();};
  },[chain.id,participation.id,reload]);
  return <main className='automation-chains chain-participation-page'>
    <a className='chain-link' href={`/automation-chains/${chain.id}/builder`}>← Chain diagram</a>
    <header className='chain-page-header'><div><h1>Player {data.player_id}</h1><p>{chain.name}</p></div></header>
    <p className='chain-help'>Times are UTC. Updates every 3 seconds. Message details come from the published scenario.</p>
    {error && <p role='alert' className='chain-error'>{error} <button className='chain-button' onClick={() => setReload((value)=>value+1)}>Retry</button></p>}
    <ParticipationDetails data={data} />
  </main>;
}
